import api from '../common/helpers/apiHelper';
import { IAttribute } from '../common/models/attribute/IAttribute';

export const getAttributes = () => api.get<IAttribute[]>('/api/attributes');
